module.exports = __webpack_public_path__ + "src/assets/img/lighting-left.38fb92ea.svg";